<template>
    <div class="app" >
        <!--头部-->
        <div class="boxTOp">
            <div id="headP">
                <div id="titleP">
                    <div class="titleRight">
                        <span v-show="!hasLogin" class="not-login-box">
                                <span @click="goLogin">登录</span>
                        <span>|</span>
                        <span @click="goRegister">注册</span>
                        <a href="http://www.acbcdc666.cn:8080" style="color:#19A2E9;margin-left:40px;font-weight:700" target="_blank">考试中心</a>
                        </span>
                        <span v-show="hasLogin" class="logined-box">
                                <img
                                    class="lazyload"
                                    src="static/img/head.png"
                                    :data-src="userAvatar"
                                />
                                <span>{{ userName ? userName : "用户名" }}</span>
                        <span>|</span>
                        <span @click="goLogout" class="logout">退出</span>
                        <span class="self-center" @click="goPerson" >个人中心</span
                                >
                            </span>
                        <!-- <span @click="goJfsc" class="jfsc-box">
                                <img class="imgJF" src="../../static/img/1.png" />
                                <span>积分商城</span>
                            </span> -->
                    </div>
                </div>
            </div>
            <div id="oneP">
                <img src="../../static/img/top.png" class="backgroundImg" />
                <div id="boxOneP">
                    <div id="oneLeftP">
                        <img @click="goIndex" class="imgLogo" src="../../static/img/4.png" />
                    </div>
                    <div id="inpP">
                        <div class="check-type-box flex-row" @click="showHideSearch">
                            <span class="checked-text">{{
                                    searchData[searchActive].text
                                }}</span>
                            <span class="iconfont">&#xe631;</span>
                            <ul v-show="showSearchData">
                                <li v-for="(item, index) in searchData" :key="index" @click="changeSearch(index)">
                                    {{ item.text }}
                                </li>
                            </ul>
                        </div>
                        <input @keyup.enter="goSearch" type="text" v-model="searchStr" id="inpVal" autocomplete="off" />
                        <span @click="goSearch" class="spanBtn">搜索</span>
                    </div>
                </div>
            </div>
            <!-- 标题 -->
            <div class="title-box">
                <ul class="title-list flex-row">
                    <li :class="activeTitle == index ? 'title-active' : ''" v-for="(item, index) in titleList" :key="index" v-show="item.status == 1" @click="goPage(index, item.id)">
                        {{ item.navigationName }}
                        <div v-if="item.subList" class="sub-title-list">
                            <div v-for="(subitem, subindex) in item.subList" :key="subindex" class="sub-title-list-item" v-show="subitem.status == 1" @click.stop="goPage(index, subitem.id)">
                                <span>{{ subitem.navigationName }}</span>
                            </div>
                        </div>
                        <!-- <li @click="goJfsc" class="jfsc-box">
    							<span>积分商城</span>
    						</li> -->
                    </li>
                </ul>
            </div>
            <!-- <div id="contentP">
                    <div id="contentLeftP" v-if="clear1">
                        <a
                            :href="advData.left.bannerUrl"
                            :target="advData.left.bannerUrl ? 'view_window' : ''"
                        >
                            <img
                                :src="advData.left.picture"
                                :alt="advData.left.bannerTitle"
                            />
                        </a>
                        <div class="iconfont clear" @click="clear1 = false">
                            &#xe66f;
                        </div>
                    </div>
                    <div id="contentRightP" v-if="clear2">
                        <a
                            :href="
                                advData.right.bannerUrl
                                    ? advData.right.bannerUrl
                                    : 'javascript:;'
                            "
                            :target="advData.right.bannerUrl ? 'view_window' : ''"
                        >
                            <img
                                :src="advData.right.picture"
                                :alt="advData.right.bannerTitle"
                            />
                        </a>
                        <div class="iconfont clear" @click="clear2 = false">
                            &#xe66f;
                        </div>
                    </div>
                </div> -->
        </div>
        <router-view></router-view>
        <!--底部-->
        <div>
            <div id="wrapBottom" style="position: relative">
                <img src="../../static/img/bottom1.jpg" class="bottomImg" />
                <div class="bottom_left">
                    <img src="../../static/img/logo.png">
                </div>
                <div class="bottom_center">
                   <ul>
                        <li>
                            日访问人次: {{ dayView }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;总访问量:{{allView}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注册人数:51190
                        </li>       
                        <li>
                            Copyright 2015　    密云全民学习网       &nbsp;&nbsp;&nbsp;All Rights Reserved 　
                        </li>       
                        <li>
                            主办：北京市密云区教育委员会　     承办：北京市密云区社区教育中心 

                        </li>       
                        <li>    
                            地址：北京市密云区新西路白云街　  邮编：10010　　电话：010-69068789
                        </li>       
                        <li>
                            交流QQ群：239173777  京ICP备 15029815     京公网安备 11011502002579号
                        </li> 
                        <li style="position:relative">
                            <a href="javascript:;" style="color:#000;" class="tickling" @click="yijian">  在线反馈</a>
                          
                            <img src="../../static/img/blue@2x.png" style="position:absolute;left:80px;">
                            <a href="http://www.hy-education.net/" style="color:#000;" class="tech-support" target="_blank">  技术支持：华佑教育</a>
                        </li>      
                   </ul>
                </div>
                <div class="bottom_right">
                    <ul>
                        <!-- <li>
                            <img src="../../static/img/002.png"><br />
                            扫一扫关注 <br />
                            密云区社区教育中心
                        </li> -->
                        <li>
                            <img src="../../static/img/003.png"> <br/>
                            扫一扫关注 <br />
                            密云全民学习网
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { setCookie, getCookie } from "@/common/util.js";
export default {
    name: "home",
    data() {
        return {
            titleList: [],
            clear1: true,
            clear2: true,
            value: 1,
            activeTitle: 0,
            searchData: [{
                    text: "视频课程",
                    type: 1
                },
                {
                    text: "资讯",
                    type: 2
                }
            ],
            searchActive: 0,
            showSearchData: false,
            searchStr: "",
            advData: {
                left: {},
                right: {}
            },
            dayView: null,
            allView: null,
            registerNum: null
        };
    },
    created() {
        this.titleList = JSON.parse(localStorage.getItem("navlist"));
        this.getTitleList();
        this.changActive(this.$route.name);
        this.imgLazyLoad();
        this.getAdv(7);
        this.getAdv(8);
        // 获取页面底部数据
        this.$ajax({
            method: "post",
            url: "homePage/getVisit",
            success: res => {
                this.allView = res.message.visitSum;
                this.registerNum = res.message.studentCount;
                this.dayView = res.message.visit_day;
            },
            error: res => {}
        });
        //计算日访问量
        //if (!getCookie("visited")) {
            this.$ajax({
                method: "post",
                url: "homePage/calculationVisit",
                success: res => {
                    setCookie("visited", "true");
                },
                error: res => {}
            });
        //}
    },
    updated() {
        this.imgLazyLoad();
    },
    methods: {
        ...mapMutations(["login", "logout", "setNavList"]),
        imgLazyLoad() {
            try {
                document.querySelectorAll(".lazyload").forEach(item => {
                    if (item.getAttribute("data-src")) {
                        var img = new Image();
                        img.onload = res => {
                            item.src = item.getAttribute("data-src");
                        };
                        img.src = item.getAttribute("data-src");
                    }
                });
            } catch (e) {}
        },
        goIndex() {
            this.$router.push({
                name: "shouye",

            });
        },
        
        yijian() {
            this.$router.push({
                name: "grzx",
                params:{alert:"true"}
            });
        },
        changActive(nval) {
            switch (nval) {
                case "shouye":
                    this.activeTitle = 0;
                    break;
                case "sqjy":
                    this.activeTitle = 1;
                    break;
                case "xljy":
                    this.activeTitle = 4;
                    break;
                case "lnjy":
                    this.activeTitle = 3;
                    break;
                case "nmjy":
                    this.activeTitle = 2;
                    break;
                case "zxkc":
                    this.activeTitle = 5;
                    break;
                case "xxhd":
                    this.activeTitle = 7;
                    break;
                case "gjtz":
                    this.activeTitle = 6;
                    break;
                case "fczs":
                    this.activeTitle = 6;
                    break;
                case "xxxmy":
                    this.activeTitle = 8;
                    break;
                case "jfsc":
                    this.activeTitle = 9;
                    break;
                default:
                    break;
            }
        },
        goPerson() {
            this.$router.push({
                name: "grzx"
            });
        },
        goPage(index, id) {

            if (id != 3 && id != 8) {
                this.activeTitle = index;
            }
            switch (id) {
                case 1:
                    this.$router.push({
                        name: "shouye"
                    });
                    break;
                case 2:
                    this.$router.push({
                        name: "sqjy"
                    });
                    break;
                case 3:
                    break;
                case 4:
                    this.$router.push({
                        name: "lnjy"
                    });
                    break;
                case 5:
                    this.$router.push({
                        name: "nmjy"
                    });
                    break;
                case 6:
                    this.$router.push({
                        name: "zxkc"
                    });
                    break;
                case 7:
                    this.$router.push({
                        name: "xxhd"
                    });
                    break;
                case 8:
                    break;
                case 9:
                    this.$router.push({
                        name: "xxxmy"
                    });
                    break;
                case 3000:
                    this.$router.push({
                        name: "xljy",
                        query: {
                            type: 1
                        }
                    });
                    break;
                case 4000:
                    this.$router.push({
                        name: "xljy",
                        query: {
                            type: 2
                        }
                    });
                    break;
                case 5000:
                    this.$router.push({
                        name: "xljy",
                        query: {
                            type: 9
                        }
                    });
                    break;
                case 9000:
                    this.$router.push({
                        name: "fczs",
                        query: {
                            type: 1
                        }
                    });
                    break;
                case 10000:
                    this.$router.push({
                        name: "gjtz",
                        query: {
                            type: 2
                        }
                    });
                    break;
                case 10:
                    this.$router.push({
                        name: "jfsc",
                    });
                    break;
                default:
                    this.$router.push({
                        name: "shouye"
                    });
                    break;
            }
        },
        changeSearch(index) {
            this.searchActive = index;
        },
        showHideSearch() {
            this.showSearchData ?
                (this.showSearchData = false) :
                (this.showSearchData = true);
        },
        goJfsc() {
            this.$router.push({
                name: "jfsc"
            });
        },
        goLogin() {
            this.$router.push({
                name: "login"
            });
        },
        goRegister() {
            this.$router.push({
                name: "register"
            });
        },
        goLogout() {
            this.logout();
        },
        // 获取标题
        getTitleList() {
            this.$ajax({
                url: "homePage/myNavigation",
                method: "post",
                success: res => {
                    if (res.code == 200) {
                        this.titleList = [];
                        var xljySubTitle = [];
                        var gjtzSubTitle = [];
                        res.message.forEach((item, index) => {
                            //                             if (item.id == 10) {
                            //                                 return;
                            //                             }
                            if (item.id == 3000 || item.id == 4000 || item.id == 5000) {
                                xljySubTitle.push({
                                    id: item.id,
                                    navigationName: item.navigationName,
                                    status: item.status
                                });
                                return;
                            }
                            if (item.id == 9000 || item.id == 10000) {
                                gjtzSubTitle.push({
                                    id: item.id,
                                    navigationName: item.navigationName,
                                    status: item.status
                                });
                                return;
                            }
                            if (item.id == 3) {
                                var subList = [];
                                item.subList.forEach((subItem, subIndex) => {
                                    if (subItem.id == 31 || subItem.id == 32) {
                                        subList.push({
                                            id: subItem.id,
                                            navigationName: subItem.navigationName,
                                            status: subItem.status
                                        });
                                    }
                                });
                                this.titleList.push({
                                    id: item.id,
                                    navigationName: item.navigationName,
                                    status: item.status,
                                    subList: subList
                                });
                                return;
                            }
                            if (item.id == 8) {
                                var subList = [];
                                item.subList.forEach((subItem, subIndex) => {
                                    if (subItem.id == 81 || subItem.id == 82) {
                                        subList.push({
                                            id: subItem.id,
                                            navigationName: subItem.navigationName,
                                            status: item.status
                                        });
                                    }
                                });
                                this.titleList.push({
                                    id: item.id,
                                    navigationName: item.navigationName,
                                    status: item.status,
                                    subList: subList
                                });
                                return;
                            }
                            this.titleList.push({
                                id: item.id,
                                navigationName: item.navigationName,
                                status: item.status,
                                subList: []
                            });
                        });

                        this.titleList.forEach((item, index) => {
                            if (item.id == 3) {
                                item.subList = xljySubTitle;
                                return;
                            }
                            if (item.id == 8) {
                                item.subList = gjtzSubTitle;
                                return;
                            }
                        });

                        localStorage.setItem(
                            "navlist",
                            JSON.stringify(this.titleList)
                        );

                        var navigation = {};
                        res.message.forEach((item, index) => {
                            navigation[item.id] = item.navigationName;
                            item.subList.forEach((subitem, subindex) => {
                                navigation[subitem.id] = subitem.navigationName;
                            });
                        });

                        this.setNavList(navigation);
                    }
                },
                error: res => {}
            });
        },
        // 搜索
        goSearch() {
            this.showSearchData ? (this.showSearchData = false) : "";
            this.activeTitle = 0;
            this.$router.push({
                name: "search",
                query: {
                    type: this.searchData[this.searchActive].type,
                    str: this.searchStr
                }
            });
        },
        // 获取广告位
        getAdv(type) {
            this.$ajax({
                method: "post",
                url: "homePage/myBanner",
                data: {
                    type: type
                },
                success: res => {
                    if (res.code == 200) {
                        if (type == 7) {
                            this.advData.left = res.message[0];
                        } else if (type == 8) {
                            this.advData.right = res.message[0];
                        }
                    }
                }
            });
        }
    },
    computed: {
        ...mapState(["hasLogin", "userToken", "userName", "userAvatar"])
    },
    watch: {
        "$route.name": function(nval) {
            switch (nval) {
                case "shouye":
                    this.activeTitle = 0;
                    break;
                case "sqjy":
                    this.activeTitle = 1;
                    break;
                case "xljy":
                    this.activeTitle = 4;
                    break;
                case "lnjy":
                    this.activeTitle = 3;
                    break;
                case "nmjy":
                    this.activeTitle = 2;
                    break;
                case "zxkc":
                    this.activeTitle = 5;
                    break;
                case "xxhd":
                    this.activeTitle = 7;
                    break;
                case "gjtz":
                    this.activeTitle = 6;
                    break;
                case "fczs":
                    this.activeTitle = 6;
                    break;
                case "xxxmy":
                    this.activeTitle = 8;
                    break;
                case "jfsc":
                    this.activeTitle = 9;
                    break;
                default:
                    break;
            }
        }
    }
};
</script>

<style scoped>
.title-box {
    width: 100%;
    /* min-width: 1000px; */
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    /* background-color: #2e82d9; */
    /* margin-bottom: 25px; */
    margin-bottom: 0 !important;
}

.title-list {
    height: 50px;
    width: 1000px;
    margin: 0 auto;
    padding-bottom: 5px;
}

.title-list li {
    /* display: inline-block;
    height: 50px;
    line-height: 50px; */
    padding: 0 10px;
    /* padding-right: 2px;
    cursor: pointer; */
}

.title-list li {
    display: inline-block;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    font-size: 16px;
    transition: all ease 0.2s;
    position: relative;
    padding-left: 25px;
}

.title-list .title-active {
    color: #6ac0e8;
}

.title-list li:nth-of-type(5):hover {
    color: #6ac0e8;
}

.title-list li .sub-title-list {
    position: absolute;
    min-width: 100%;
    height: 0;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0 3px 2px rgba(0, 0, 0, 0.2);
    z-index: 10;
    top: 50px;
    left: 10px;
    transition: all ease 0.2s;
}

.title-list li .sub-title-list-item {
    height: 30px;
    line-height: 30px;
    margin: 15px 0;
    text-align: center;
}

.title-list li .sub-title-list-item span {
    color: #000;
    display: inline-block;
    min-width: 80%;
    max-width: 130px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: 0 auto;
    margin: 0 10px;
}

.title-list li .sub-title-list-item span:hover {
    color: #6ac0e8;
}
.title-list li:hover>.sub-title-list {
    height: auto;
}
.title-list li:nth-of-type(5):hover>.sub-title-list {
    height: auto;
}
.title-list li:nth-of-type(7):hover>.sub-title-list  {
    height: auto;
}

/*  */

input {
    outline: none;
    border: none;
}

.boxTop {
    height: 327px;
    overflow: hidden;
}

#headP {
    width: 100%;
    font-size: 14px;
}

#titleP {
    width: 1000px;
    height: 37px;
    line-height: 37px;
    margin: 0 auto;
    font-size: 12px;
    color: gray;
}

#titleLeft {
    float: left;
}

#wrapP {
    width: 1000px;
    margin: 0 auto;
}

#twoP {
    width: 1000px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    text-align-last: left;
    -moz-text-align-last: left;
}

.spansP {
    cursor: pointer;
}

#oneP {
    width: 100%;
    height: 170px;
    margin: 0 auto;
    clear: both;
    position: relative;
    min-width: 1000px;
}

.backgroundImg {
    position: absolute;
    width: 100%;
    height: 170px;
    top: 0;
    left: 0;
    min-width: 1000px;
}

#boxOneP {
    width: 1000px;
    margin: 0 auto;
    position: relative;
}

#oneLeftP {
    position: absolute;
    top: 30px;
    left: 40px;
    cursor: pointer;
}

#oneLeftP img {
    vertical-align: middle;
}

/* 搜索框 */

#inpP {
    position: absolute;
    top: 120px;
    right: 30px;
    border: 2px solid #6ac0e8;
    background-color: #6ac0e8;
    z-index: 10;
}

#inpP .check-type-box {
    width: 95px;
    height: 30px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #fff;
    cursor: pointer;
    justify-content: space-between;
}

#inpP .check-type-box .checked-text {
    padding: 0 0 0 8px;
    display: inline-block;
    height: 30px;
    line-height: 30px;
    color: #6ac0e8;
}

#inpP .check-type-box .iconfont {
    padding: 0;
    display: inline-block;
    height: 30px;
    line-height: 30px;
    color: #6ac0e8;
}

#inpP .check-type-box ul {
    position: absolute;
    left: -2px;
    top: 30px;
    width: 100px;
    background-color: #fff;
    border: 2px solid #6ac0e8;
    border-top: 0;
}

#inpP .check-type-box li {
    text-indent: 5px;
    line-height: 30px;
}

#inpP .check-type-box li:hover {
    color: #6ac0e8;
}

.selectInp {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    border: 0;
    color: #6ac0e8;
    float: left;
    text-align: center;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
}

#inpVal {
    outline: none;
    height: 30px;
    text-indent: 100px;
    width: 287px;
    float: left;
}

.spanBtn {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    background-color: #6ac0e8;
    color: white;
    padding: 0 15px;
    cursor: default;
}

.spanBtn:hover {
    color: #000;
}

#contentP {
    width: 1000px;
    margin: 13px auto;
    z-index: 100;
}

/* 广告位 */

#contentLeftP .iconfont:hover,
#contentRightP .iconfont:hover {
    cursor: pointer;
}

#contentLeftP {
    margin-left: 50.5% !important;
}

#contentRightP {
    margin-left: 49.5% !important;
}

#contentLeftP,
#contentRightP {
    background-color: #eee;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
}

#contentLeftP img,
#contentRightP img {
    width: 267px;
    vertical-align: middle;
}

#contentLeftP a,
#contentRightP a {
    display: inline-block;
    vertical-align: middle;
}

@media screen and (max-width: 1583px) {
    #contentLeftP,
    #contentRightP {
        border: 1px solid #ddd;
        position: absolute;
        z-index: 100;
        width: 180px;
    }
    #contentLeftP img,
    #contentRightP img {
        width: 180px;
        height: 283px;
        vertical-align: middle;
    }
    #contentLeftP {
        width: 150px;
        left: 15px;
        left: -645px;
    }
    #contentRightP {
        width: 150px;
        right: 165px;
    }
    .clear {
        position: absolute;
        right: -40px !important;
    }
    #routerP {
        width: 1000px;
        box-sizing: border-box;
        border: 1px solid gainsboro;
    }
}

@media screen and (max-width: 1449px) {
    #contentRightP {
        width: 150px;
        left: 465px;
    }
}

@media screen and (min-width: 1450px) {
    #contentRightP {
        width: 150px;
        left: 465px;
    }
}

@media screen and (max-width: 1366px) {
    #contentRightP {
        width: 150px;
        left: 465px;
    }
}

@media screen and (min-width: 1583px) {
    #contentLeftP,
    #contentRightP {
        position: absolute;
        z-index: 100;
    }
    #contentLeftP {
        width: 150px;
        margin-left: 50%;
        left: -785px;
    }
    #contentRightP {
        width: 150px;
        margin-left: 50%;
        left: 520px;
    }
    #routerP {
        width: 1000px;
        box-sizing: border-box;
        border: 1px solid gainsboro;
    }
}

.clear {
    width: 20px;
    height: 20px;
    line-height: 20px;
    position: absolute;
    top: -10px;
    right: -125px;
    z-index: 100;
}

.spanHover {
    position: relative;
}

.spanHover:hover .hover {
    display: block;
}

.hover {
    position: absolute;
    top: 0px;
    left: -1px;
    width: 70px;
    z-index: 10;
    display: none;
}

.kong {
    margin-top: 30px;
    border: 1px solid black;
    z-index: 11;
    background-color: white;
}

.hoverOneDiv,
.hoverTwoDiv {
    padding: 10px 2px;
}

#wrapBottom {
    height: 212px;
    position: relative;
}

.bottomImg {
    width: 100%;
    height: 212px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    min-width: 1000px;
}

/* 友情链接 */

#spanBottom {
    color: black;
    font-size: 18px;
}

.a1Bottom {
    color: #696969;
    font-size: 14px;
}

.oneBottom {
    box-sizing: border-box;
    padding-top: 30px;
    color: black;
    margin-left: 5px;
}

/* 底部导航 */

.twoBottom {
    width: 1000px;
    box-sizing: border-box;
    padding: 10px 0 5px 0;
    text-align: center;
    margin: 0 auto;
}

.threeBottom,
.fourBottom {
    font-size: 14px;
    padding: 3px 0;
    color: black;
    padding-left:39px;
}

.a2Bottom {
    color: white;
}

select {
    text-align: center;
    text-align-last: center;
}

/* 顶部状态 */

.titleRight {
    float: right;
}

.titleRight .not-login-box {
    margin-right: 10px;
}

.titleRight .not-login-box span {
    cursor: pointer;
    padding: 0 3px;
    color: #19A2E9;
    font-weight: 700;
}

.titleRight .not-login-box span:hover {
    color: #000;
}

.titleRight .not-login-box span:nth-child(2) {
    cursor: default;
}

.titleRight .not-login-box span:nth-child(2):hover {
    color: gray;
}

/* 登录状态 */

.titleRight .logined-box {
    margin-right: 15px;
}

.titleRight .logined-box img {
    height: 24px;
    width: 24px;
    border-radius: 12px;
    vertical-align: middle;
}

.titleRight .logined-box .logout:hover {
    color: #000;
    cursor: pointer;
}

/* 积分商城 */

.titleRight .jfsc-box img {
    vertical-align: middle;
}

.titleRight .jfsc-box:hover {
    cursor: pointer;
    color: #000;
}

.titleRight .jfsc-box span {
    vertical-align: middle;
}

.self-center {
    margin-left: 10px;
    cursor: pointer;
}

.self-center:hover {
    color: #6ac0e8;
}
.bottom_left {
    position:absolute;
    left: 16%;
    top: 76.5px;
    width: 16.5%;
}
.bottom_left img  {
    width: 100%;
    height: auto;
    min-width: 230px;
}
.bottom_center {
    position:absolute;
    left: 38%;
    top: 30px;
}
.bottom_right {
    margin-left: 70%;
    padding-top:40px; 
}
.bottom_right ul li {
    text-align:center;
    float:left;
    margin-right: 20px;
    font-size: 11px;
}
.bottom_right ul li img {
    width: 104px;
    height: 105px;
}
.bottom_center ul li {
    height: 25px;
    line-height:25px;
    font-size: 13px;
}
.tickling:hover {
   text-decoration:underline;
}
@media screen and (max-width: 1600px) {
    .bottom_right {
        margin-left:1100px;
        padding-top:40px; 
    }
}
@media screen and (max-width: 1400px) {
    .bottom_right {
        margin-left:1050px;
        padding-top:40px; 
    }
}
@media screen and (max-width: 1366px) {
    .bottom_right {
        margin-left:1000px;
        padding-top:40px; 
    }
}
@media screen and (max-width: 1000px)  {
    .bottom_right {
        display:none;
    }
    .bottom_left {
        left: 10%;
    }
    .bottom_left img {
        min-width: 200px;
    }
}
.tech-support{
    position: absolute;
    left: 130px;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue